import classNames from "classnames";
import {useSaleOtherArticlesCarousel} from "../model/useSaleOtherArticlesCarousel";
import {formatDMY} from "@/shared/lib/date";
import {Svg} from "@/shared/ui/Svg";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {Button} from "@/shared/ui/Button";
import styles from "./SaleOtherArticles.module.scss";

type Article = {
    id: number;
    img: string;
    img_mobile: string;
    name: string;
    alias: string;
    published_start: string;
    published_end: string;
}

type Props = {
    titleSection: string;
    articles: Article[];
}

export const SaleOtherArticles = ({titleSection, articles}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useSaleOtherArticlesCarousel();

    if (articles.length === 0) return null;

    return (
        <div className={styles.container}>
            <p className={styles.titleSection}>{titleSection}</p>
            <div className={styles.carousel}>
                <div ref={carouselRef} className={styles.carouselViewport}>
                    <div className={styles.carouselContainer}>
                        {articles.map((article) => {
                            return (
                                <Link key={article.id} href={`/stocks/${article.alias}`} className={styles.card}>
                                    <Picture
                                        src={article.img_mobile}
                                        srcMobile={article.img_mobile}
                                        alt={article.name}
                                        classes={{image: styles.image}}
                                    />
                                    <div className={styles.content}>
                                        <div>
                                            <p className={styles.title}>{article.name}</p>
                                            <p className={styles.date}>
                                                c {formatDMY(article.published_start)} по {formatDMY(article.published_end)}
                                            </p>
                                        </div>
                                        <Button variant={`secondary`} fullWidth>Подробнее</Button>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
                {articles.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
